import { render } from "./journal-v1-entry.vue?vue&type=template&id=6fcdd736"
import script from "./journal-v1-entry.vue?vue&type=script&lang=js"
export * from "./journal-v1-entry.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__